import React from 'react';
import PropTypes from 'prop-types';
import { setValueLocalized } from '../../../../store/actions';
import useComponent from '../../../../hooks/useComponent';

const initialState = {
  data: {
    type: 'Embed',
    code: {
      en: '',
      es: '',
      ca: '',
      pt: '',
    },
  },
  error: false,
};


const Embed = ({ components, handlerSetComponents, id, activeLanguage }) => {
  const { state: { data }, dispatch } = useComponent({ components, id, initialState, setComponents: handlerSetComponents });

  const handleLocalizedInput = (e) => {
    const { name, value } = e.target;
    setValueLocalized(dispatch)(name, value, activeLanguage);
  };

  return (
    <>
      <div>
        <div className="text-black font-semibold text-sm">
          Introduce your embed code here:
        </div>
        <textarea className="appearance-none block w-full h-125px bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 my-3 leading-tight focus:outline-none focus:bg-white" type="text" name="code" onChange={handleLocalizedInput} value={data?.code[activeLanguage]} />
      </div>
    </>
  );
};

Embed.propTypes = {
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  activeLanguage: PropTypes.string.isRequired,
};

export default Embed;
